import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthorizedServicesProcedur } from '../models/models'

export class GetAuthorizedServicesProcedurApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesProcedur/listAll',
      requesterInfo,
    })
  }

  public async getAuthorizedServicesProcedur(): Promise<IAuthorizedServicesProcedur[]> {
    return await this.getAsync<IAuthorizedServicesProcedur[]>()
  }
}
